import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import type React from 'react';

interface LoadingStateProps {
  minHeight?: number;
  size?: number;
}

const LoadingState: React.FC<LoadingStateProps> = ({ minHeight = 400, size = 60 }) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight }}>
      <CircularProgress size={size} />
    </Box>
  );
};

export default LoadingState;
